<template>
<div class="print_block">
  <h1>上聯展覽</h1>
  <p style="max-width:850px;">
    <ul style="list-style-type:none;margin:0;padding:0;">
      <li>※ 貴單位申請的參展資料已成功送出，大會將於<span style="color:red;">七個工作日內</span>回覆初審結果。</li>
      <li>※ 若您要查詢您的報名紀錄，請至上聯官網選擇「<span style="color:red;">廠商專區</span> / <span style="color:red;">報名參展記錄</span>」查詢您的所有報名紀錄及進度。</li>
      <li>※ 若您有任何疑問請逕洽 02-2759-7167 大會承辦人。</li>
    </ul>
  </p>
  <div class="print_table">
    <table>
      <tr>
        <th>帳號/公司統編</th>
        <td>89615825</td>
        <th>報名時間</th>
        <td>2016-12-13 16:20:57</td>
      </tr>
      <tr>
        <th>初　　審</th>
        <td>已通過</td>
        <th>繳　　款</th>
        <td>請款中</td>
      </tr>
      <tr>
        <th>複　　審</th>
        <td>尚未進入複審</td>
        <th></th>
        <td></td>
      </tr>
      <!-- 攤位資訊 -->
      <tr class="print_table_title">
        <th colspan="4">攤　位　資　訊</th>
      </tr>
      <tr>
        <th>展覽類別</th>
        <td>嬰兒與孕媽咪用品展</td>
        <th>大會承辦人</th>
        <td>有，姓名：陳先生</td>
      </tr>
      <tr>
        <th rowspan="2">展覽檔期&amp;攤位資訊</th>
        <td colspan="3">2017.09.02~05 台中朝馬展覽館<br>A.XXXXX區，標準攤位2格，委託大會基本裝潢</td>
      </tr>
      <tr>
        <td colspan="3">2017.11.02~05 台北世貿一館<br>A.XXXXX區，標準攤位2格，委託大會基本裝潢</td>
      </tr>
      <tr>
        <th>注意事項</th>
        <td colspan="3">
          <ol style="list-style-position:inside;margin:0;padding:5px 0;">
            <li>以上報價為每一標準攤位3Mx3M（含基本裝潢及5％營業稅）。</li>
            <li>不含基本裝潢者，每一攤位退款新台幣2,000元整。</li>
            <li>若抽籤選位時，選至兩邊走道之攤位(角位)，每個角位另需加收新台幣3,000元整。</li>
            <li>以上標準攤位用不包含場地供電端至攤位內之電力佈線及器材費用(詳細訊息請洽大會裝潢公司)。</li>
          </ol>
        </td>
      </tr>
      <!-- 廠商資訊 -->
      <tr class="print_table_title">
        <th colspan="4">廠　商　資　訊</th>
      </tr>
      <tr>
        <th>公司/機關名稱</th>
        <td colspan="3">上聯國際展覽有限公司</td>
      </tr>
      <tr>
        <th>負責人 姓名</th>
        <td>時瑤如</td>
        <th>負責人 職稱</th>
        <td>董事長</td>
      </tr>
      <tr>
        <th>公司地址</th>
        <td colspan="3">11100 台北市信義區忠孝東路五段550號4樓</td>
      </tr>
      <!-- 參展資訊 -->
      <tr class="print_table_title">
        <th colspan="4">參　展　資　訊</th>
      </tr>
      <tr>
        <th>招牌名稱 中文</th>
        <td colspan="3">上聯國際展覽</td>
      </tr>
      <tr>
        <th>招牌名稱 英文</th>
        <td colspan="3">Top Link International Exhibition Co. ,LTD</td>
      </tr>
      <tr>
        <th>承辦人 姓名</th>
        <td>陳先生</td>
        <th>承辦人 職稱</th>
        <td>企劃專員</td>
      </tr>
      <tr>
        <th>承辦人 公司電話</th>
        <td>02-2756-7167</td>
        <th>承辦人 手機號碼</th>
        <td>0912345678</td>
      </tr>
      <tr>
        <th>承辦人 傳真號碼</th>
        <td></td>
        <th>承辦人 E-mail</th>
        <td>aaa@top-link.com.tw</td>
      </tr>
      <tr>
        <th>付款方式</th>
        <td>匯款</td>
        <th>發票統編</th>
        <td>89615825</td>
      </tr>
      <tr>
        <th>發票抬頭</th>
        <td colspan="3">上聯國際展覽有限公司</td>
      </tr>
      <tr>
        <th>發票寄送地址</th>
        <td colspan="3">11100 台北市信義區忠孝東路五段550號4樓</td>
      </tr>
      <tr>
        <td style="text-align:center;font-size:0.9rem;" colspan="4">Copyrights ©2016 All Rights Reserved by Top-Link. 　　　<img src="@/assets/icons/footer_mail.png"> CRM@top-link.com.tw 　　　<img src="@/assets/icons/footer_tel.png"> 02-2759-7167</td>
      </tr>
    </table>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return{};
  }
}
</script>

<style>
.print_block {
  width:992px;
  margin:auto;
}
.print_block h1 {
  border:1px solid #666666;
  text-align:center;
  font-weight:bold;
  font-size:2rem;
  padding:7px 0;
}

.print_table {
  overflow:auto;
}
.print_table table {
  width:992px;
  margin:auto;
}
.print_table tr {
  height:48px;
}
.print_table th,
.print_table td {
  border:1px solid #666666;
}
.print_table th {
  width:180px;
  text-align:right;
  padding-right:10px;
}
.print_table_title th {
  text-align:center;
  height:48px;
  margin:0;
  background:#666666;
  color:white;
  font-size:1.2rem;
}
.print_table td {
  width:320px;
  padding-left:10px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/apply_success.vue